import React from 'react';
import TrainingsComp from '../../Components/Trainings/TrainingsComp';

function Trainings() {
  return (
    <>
      <TrainingsComp />
    </>
  );
}

export default Trainings;
